import React, { FC } from 'react';
import { Box } from 'roo-ui/components';
import { DateRangeRenderProps } from '../../types';
import { DesktopActions } from '../DesktopActions';

export const InlineLayout: FC<DateRangeRenderProps> = ({ children, ...rest }) => {
  return (
    <Box border="1" borderColor="greys.alto" boxShadow="modal" bg="greys.porcelain">
      {children}
      <DesktopActions {...rest} />
    </Box>
  );
};
